import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';

interface BlogPost {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: string;
  image: string;
}

const blogPosts: BlogPost[] = [
  {
    id: 1,
    slug: 'fiber-optik-kablo-tamiri-nasil-yapilir',
    title: 'Fiber Optik Kablo Tamiri Nasıl Yapılır? Profesyonel Rehber',
    excerpt: 'Fiber optik kablo tamiri, yüksek hız internet ve veri iletişiminin kesintisiz devamı için kritik öneme sahiptir. Bu rehberde fusion splicing tekniği ve OTDR test yöntemlerini detaylı olarak öğrenin.',
    category: 'Fiber Optik',
    date: '15 Mayıs 2024',
    readTime: '8 dakika',
    image: 'https://public.readdy.ai/ai/img_res/1622160ec6e8fca05ee60d756b884225.jpg'
  },
  {
    id: 2,
    slug: 'otdr-testi-nedir',
    title: 'OTDR Testi Nedir? Fiber Optik Arıza Tespitinde Kullanımı',
    excerpt: 'OTDR (Optical Time Domain Reflectometer) testi, fiber optik kablolardaki arızaları tespit etmek için kullanılan en gelişmiş yöntemdir. Çalışma prensibi ve uygulama alanlarını keşfedin.',
    category: 'Fiber Optik',
    date: '12 Mayıs 2024',
    readTime: '7 dakika',
    image: 'https://readdy.ai/api/search-image?query=OTDR%20testing%20device%20screen%20showing%20fiber%20optic%20cable%20measurement%20results%20with%20graphs%20and%20technical%20data%20in%20modern%20laboratory%20environment%20clean%20white%20background%20professional%20equipment%20photography&width=800&height=500&seq=blog2&orientation=landscape'
  },
  {
    id: 3,
    slug: 'yanlislikla-kesilen-fiber-kablo-nasil-onarilir',
    title: 'Yanlışlıkla Kesilen Fiber Kablo Nasıl Onarılır? Acil Müdahale',
    excerpt: 'İnşaat veya kazı çalışmaları sırasında yanlışlıkla kesilen fiber optik kablolar için acil onarım prosedürleri ve 7/24 müdahale hizmetleri hakkında bilmeniz gerekenler.',
    category: 'Fiber Optik',
    date: '10 Mayıs 2024',
    readTime: '6 dakika',
    image: 'https://readdy.ai/api/search-image?query=emergency%20fiber%20optic%20cable%20repair%20at%20construction%20site%20with%20cut%20cable%20and%20repair%20equipment%20technician%20working%20urgently%20industrial%20environment%20clean%20background&width=800&height=500&seq=blog3&orientation=landscape'
  },
  {
    id: 4,
    slug: 'fabrikalarda-fiber-altyapi-rehberi',
    title: 'Fabrikalarda Fiber Altyapı Kurulumu: Kapsamlı Rehber',
    excerpt: 'Endüstriyel tesislerde fiber optik altyapı kurulumu için planlama, uygulama ve bakım süreçleri. Sanayi 4.0 için gerekli fiber optik çözümler ve OSB uygulamaları.',
    category: 'Fiber Optik',
    date: '8 Mayıs 2024',
    readTime: '10 dakika',
    image: 'https://readdy.ai/api/search-image?query=modern%20factory%20interior%20with%20fiber%20optic%20cable%20infrastructure%20installation%20industrial%20machinery%20and%20network%20equipment%20blue%20glowing%20cables%20organized%20cable%20management%20system%20clean%20professional%20photography&width=800&height=500&seq=blog4&orientation=landscape'
  },
  {
    id: 5,
    slug: 'fusion-splicing-nedir',
    title: 'Fusion Splicing Nedir? Fiber Optik Ek Teknolojisi',
    excerpt: 'Fusion splicing, fiber optik kabloların kaynaştırılarak birleştirilmesi işlemidir. SC, LC konnektör sonlandırma teknikleri ve OM3, OM4 fiber ek uygulamaları hakkında detaylı bilgi.',
    category: 'Fiber Optik',
    date: '5 Mayıs 2024',
    readTime: '9 dakika',
    image: 'https://readdy.ai/api/search-image?query=fusion%20splicing%20machine%20welding%20fiber%20optic%20cables%20close-up%20view%20with%20blue%20arc%20light%20precision%20equipment%20and%20fiber%20strands%20technical%20photography%20clean%20white%20background&width=800&height=500&seq=blog5&orientation=landscape'
  },
  {
    id: 6,
    slug: 'ip-kamera-secim-rehberi',
    title: 'IP Kamera Seçim Rehberi: Doğru Güvenlik Kamerası Nasıl Seçilir?',
    excerpt: 'Fabrika, sanayi tesisi ve kurumsal işletmeler için IP kamera seçiminde dikkat edilmesi gereken teknik özellikler, çözünürlük, gece görüş ve depolama kapasitesi kriterleri.',
    category: 'Güvenlik Sistemleri',
    date: '3 Mayıs 2024',
    readTime: '8 dakika',
    image: 'https://readdy.ai/api/search-image?query=modern%20IP%20security%20camera%20with%20night%20vision%20lens%20mounted%20on%20wall%20industrial%20setting%20high-tech%20surveillance%20equipment%20clean%20white%20background%20professional%20product%20photography&width=800&height=500&seq=blog6&orientation=landscape'
  },
  {
    id: 7,
    slug: 'hirsiz-alarm-sistemi-calisma-mantigi',
    title: 'Hırsız Alarm Sistemi Çalışma Mantığı ve Uygulama Alanları',
    excerpt: 'Hırsız alarm sistemlerinin çalışma prensibi, sensör tipleri, kablosuz ve kablolu sistemler arasındaki farklar. Fabrika ve sanayi tesisleri için özel alarm çözümleri.',
    category: 'Güvenlik Sistemleri',
    date: '1 Mayıs 2024',
    readTime: '7 dakika',
    image: 'https://readdy.ai/api/search-image?query=burglar%20alarm%20system%20control%20panel%20with%20motion%20sensors%20and%20door%20contacts%20on%20wall%20modern%20security%20equipment%20industrial%20facility%20clean%20background%20professional%20photography&width=800&height=500&seq=blog7&orientation=landscape'
  },
  {
    id: 8,
    slug: 'yangin-alarm-yonetmelikleri',
    title: 'Yangın Alarm Yönetmelikleri: TSE ve Yasal Gereklilikler',
    excerpt: 'Türkiye\'de yangın alarm sistemleri için geçerli TSE standartları, yasal yönetmelikler ve zorunlu periyodik bakım gereksinimleri. Fabrika ve sanayi tesisleri için özel düzenlemeler.',
    category: 'Güvenlik Sistemleri',
    date: '28 Nisan 2024',
    readTime: '9 dakika',
    image: 'https://readdy.ai/api/search-image?query=fire%20alarm%20system%20with%20smoke%20detectors%20and%20emergency%20warning%20lights%20on%20ceiling%20industrial%20building%20red%20alert%20indicators%20professional%20safety%20equipment%20clean%20background&width=800&height=500&seq=blog8&orientation=landscape'
  },
  {
    id: 9,
    slug: 'bariyer-turnike-sistemleri-kullanim-alanlari',
    title: 'Bariyer ve Turnike Sistemleri: Kullanım Alanları ve Seçim Kriterleri',
    excerpt: 'Fabrika girişleri, otopark yönetimi ve personel geçiş kontrolü için bariyer ve turnike sistemleri. Plaka tanıma, kartlı geçiş ve biyometrik entegrasyon seçenekleri.',
    category: 'Güvenlik Sistemleri',
    date: '25 Nisan 2024',
    readTime: '8 dakika',
    image: 'https://readdy.ai/api/search-image?query=modern%20turnstile%20and%20barrier%20gate%20system%20at%20factory%20entrance%20with%20access%20control%20panel%20stainless%20steel%20equipment%20industrial%20security%20installation%20clean%20professional%20photography&width=800&height=500&seq=blog9&orientation=landscape'
  },
  {
    id: 10,
    slug: 'sanayi-bolgelerinde-fiber-altyapi-onemi',
    title: 'Sanayi Bölgelerinde Fiber Altyapı Önemi: OSB\'lerde Dijital Dönüşüm',
    excerpt: 'Organize Sanayi Bölgelerinde fiber optik altyapının önemi, Sanayi 4.0 uygulamaları ve yüksek hızlı internet ihtiyacı. Gebze, Tuzla, Kocaeli OSB\'lerinde fiber çözümler.',
    category: 'Fiber Optik',
    date: '22 Nisan 2024',
    readTime: '10 dakika',
    image: 'https://readdy.ai/api/search-image?query=organized%20industrial%20zone%20aerial%20view%20with%20modern%20factories%20and%20fiber%20optic%20network%20infrastructure%20blue%20glowing%20connection%20lines%20digital%20transformation%20concept%20clean%20professional%20photography&width=800&height=500&seq=blog10&orientation=landscape'
  },
  {
    id: 11,
    slug: 'hirsiz-alarm-sistemi-calisma-mantigi',
    title: 'Hırsız Alarm Sistemi Çalışma Mantığı',
    excerpt: 'Modern hırsız alarm sistemlerinin çalışma prensibi, sensör türleri ve fabrika uygulamaları hakkında detaylı bilgiler.',
    image: 'https://readdy.ai/api/search-image?query=security%20alarm%20system%20control%20panel%20with%20motion%20sensors%20PIR%20detectors%20magnetic%20contacts%20in%20industrial%20setting%2C%20professional%20security%20technology%20equipment&width=400&height=250&seq=hirsiz-alarm-blog&orientation=landscape',
    category: 'Güvenlik Sistemleri',
    date: '15 Ocak 2025',
    readTime: '8 dakika'
  },
  {
    id: 12,
    slug: 'yangin-alarm-yonetmelikleri',
    title: 'Yangın Alarm Yönetmelikleri ve TSE Standartları',
    excerpt: 'Yangın alarm sistemi yönetmelikleri, TSE EN 54 standartları ve dedektör türleri hakkında kapsamlı rehber.',
    image: 'https://readdy.ai/api/search-image?query=fire%20alarm%20control%20panel%20with%20smoke%20detectors%20heat%20sensors%20flame%20detectors%20TSE%20standard%20compliant%20system%20in%20modern%20building&width=400&height=250&seq=yangin-alarm-blog&orientation=landscape',
    category: 'Güvenlik Sistemleri',
    date: '15 Ocak 2025',
    readTime: '7 dakika'
  },
  {
    id: 13,
    slug: 'bariyer-turnike-sistemleri-kullanim-alanlari',
    title: 'Bariyer ve Turnike Sistemleri Kullanım Alanları',
    excerpt: 'Bariyer ve turnike sistemlerinin kullanım alanları, plaka tanıma teknolojisi ve seçim kriterleri rehberi.',
    image: 'https://readdy.ai/api/search-image?query=automatic%20vehicle%20barrier%20gate%20with%20license%20plate%20recognition%20camera%20and%20pedestrian%20turnstile%20at%20factory%20entrance%2C%20modern%20access%20control%20equipment&width=400&height=250&seq=bariyer-turnike-blog&orientation=landscape',
    category: 'Güvenlik Sistemleri',
    date: '15 Ocak 2025',
    readTime: '9 dakika'
  }
];

const shareButtonStyles = `
  @keyframes popIn {
    0% { transform: scale(1); }
    50% { transform: scale(1.35); }
    100% { transform: scale(1.2); }
  }
  @keyframes wiggle {
    0%, 100% { transform: rotate(0deg) scale(1); }
    25% { transform: rotate(-8deg) scale(1.1); }
    75% { transform: rotate(8deg) scale(1.1); }
  }
  .share-btn {
    transition: all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  .share-btn:hover {
    animation: popIn 0.3s ease forwards;
  }
  .share-btn-fb:hover {
    background-color: #1877f2 !important;
    color: white !important;
    box-shadow: 0 4px 14px rgba(24,119,242,0.5);
  }
  .share-btn-tw:hover {
    background-color: #000 !important;
    color: white !important;
    box-shadow: 0 4px 14px rgba(0,0,0,0.4);
  }
  .share-btn-wa:hover {
    background-color: #25d366 !important;
    color: white !important;
    box-shadow: 0 4px 14px rgba(37,211,102,0.5);
  }
`;

export default function BlogPage() {
  const [selectedCategory, setSelectedCategory] = useState<string>('Tümü');
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [sortBy, setSortBy] = useState<string>('newest');
  const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = 'Blog | Fiber Optik ve Güvenlik Sistemleri Rehberi - Fiber Ek';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Fiber optik kablo tamiri, OTDR testi, fusion splicing, IP kamera, yangın alarm ve güvenlik sistemleri hakkında uzman rehberleri. Fiber Ek blog sayfası.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Fiber optik kablo tamiri, OTDR testi, fusion splicing, IP kamera, yangın alarm ve güvenlik sistemleri hakkında uzman rehberleri. Fiber Ek blog sayfası.';
      document.head.appendChild(meta);
    }

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Blog | Fiber Optik ve Güvenlik Sistemleri Rehberi - Fiber Ek');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:title');
      meta.content = 'Blog | Fiber Optik ve Güvenlik Sistemleri Rehberi - Fiber Ek';
      document.head.appendChild(meta);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Fiber optik ve güvenlik sistemleri hakkında uzman rehberleri, teknik makaleler ve sektör haberleri.');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:description');
      meta.content = 'Fiber optik ve güvenlik sistemleri hakkında uzman rehberleri, teknik makaleler ve sektör haberleri.';
      document.head.appendChild(meta);
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://fiberek.com/blog');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:url');
      meta.content = 'https://fiberek.com/blog';
      document.head.appendChild(meta);
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://fiberek.com/blog');
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = 'https://fiberek.com/blog';
      document.head.appendChild(link);
    }

    // Blog + ItemList Schema
    const schemaId = 'blog-page-schema';
    if (!document.getElementById(schemaId)) {
      const script = document.createElement('script');
      script.id = schemaId;
      script.type = 'application/ld+json';
      script.text = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Blog",
        "name": "Fiber Ek Blog",
        "url": "https://fiberek.com/blog",
        "description": "Fiber optik ve güvenlik sistemleri hakkında uzman rehberleri ve teknik makaleler.",
        "publisher": {
          "@type": "Organization",
          "name": "Fiber Ek",
          "url": "https://fiberek.com"
        },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://fiberek.com/" },
            { "@type": "ListItem", "position": 2, "name": "Blog", "item": "https://fiberek.com/blog" }
          ]
        }
      });
      document.head.appendChild(script);
    }

    return () => {
      document.title = 'Fiber Ek';
      const s = document.getElementById(schemaId);
      if (s) s.remove();
    };
  }, []);

  // Kategori sayılarını hesapla
  const fiberCount = blogPosts.filter(post => post.category === 'Fiber Optik').length;
  const securityCount = blogPosts.filter(post => post.category === 'Güvenlik Sistemleri').length;

  // Filtrelenmiş ve aranmış blog yazıları
  const getFilteredPosts = () => {
    let filtered = blogPosts;

    // Kategori filtresi
    if (selectedCategory !== 'Tümü') {
      filtered = filtered.filter(post => post.category === selectedCategory);
    }

    // Arama filtresi
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase().trim();
      filtered = filtered.filter(post => 
        post.title.toLowerCase().includes(query) ||
        post.excerpt.toLowerCase().includes(query) ||
        post.category.toLowerCase().includes(query)
      );
    }

    // Sıralama
    filtered = [...filtered].sort((a, b) => {
      switch (sortBy) {
        case 'newest':
          return new Date(b.date).getTime() - new Date(a.date).getTime();
        case 'oldest':
          return new Date(a.date).getTime() - new Date(b.date).getTime();
        case 'title':
          return a.title.localeCompare(b.title, 'tr');
        case 'readTime':
          return parseInt(a.readTime) - parseInt(b.readTime);
        default:
          return 0;
      }
    });

    return filtered;
  };

  const filteredPosts = getFilteredPosts();

  const clearFilters = () => {
    setSelectedCategory('Tümü');
    setSearchQuery('');
    setSortBy('newest');
  };

  // Sosyal medya paylaşım fonksiyonları
  const shareOnFacebook = (e: React.MouseEvent, post: BlogPost) => {
    e.preventDefault();
    e.stopPropagation();
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${window.location.origin}/blog/${post.slug}`)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const shareOnTwitter = (e: React.MouseEvent, post: BlogPost) => {
    e.preventDefault();
    e.stopPropagation();
    const url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(`${window.location.origin}/blog/${post.slug}`)}&text=${encodeURIComponent(post.title)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const shareOnWhatsApp = (e: React.MouseEvent, post: BlogPost) => {
    e.preventDefault();
    e.stopPropagation();
    const text = `${post.title} - ${window.location.origin}/blog/${post.slug}`;
    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="min-h-screen bg-white">
      <style>{shareButtonStyles}</style>
      <Navbar />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 overflow-hidden">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iIzE0QjhBNiIgc3Ryb2tlLW9wYWNpdHk9Ii4xIi8+PC9nPjwvc3ZnPg==')] opacity-20"></div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-500/10 border border-teal-500/20 rounded-full mb-6">
              <i className="ri-article-line text-teal-400"></i>
              <span className="text-sm font-medium text-teal-400">Bilgi Merkezi</span>
            </div>
            
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Fiber Optik ve Güvenlik Sistemleri <span className="text-teal-400">Blog</span>
            </h1>
            
            <p className="text-xl text-slate-300 mb-8 leading-relaxed">
              Fiber optik teknolojileri, güvenlik sistemleri ve endüstriyel çözümler hakkında uzman görüşleri, teknik rehberler ve sektör haberleri
            </p>

            <div className="flex flex-wrap items-center justify-center gap-4">
              <div className="flex items-center gap-2 text-slate-300">
                <i className="ri-file-text-line text-teal-400"></i>
                <span className="text-sm">{blogPosts.length}+ Detaylı Makale</span>
              </div>
              <div className="w-1 h-1 bg-slate-600 rounded-full"></div>
              <div className="flex items-center gap-2 text-slate-300">
                <i className="ri-user-line text-teal-400"></i>
                <span className="text-sm">Uzman Yazarlar</span>
              </div>
              <div className="w-1 h-1 bg-slate-600 rounded-full"></div>
              <div className="flex items-center gap-2 text-slate-300">
                <i className="ri-time-line text-teal-400"></i>
                <span className="text-sm">Düzenli Güncelleme</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Search & Filter Section */}
      <section className="py-8 bg-slate-50 border-b border-slate-200 sticky top-0 z-40 backdrop-blur-sm bg-slate-50/95">
        <div className="container mx-auto px-6">
          {/* Arama Kutusu */}
          <div className="max-w-2xl mx-auto mb-6">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <i className="ri-search-line text-slate-400 text-lg"></i>
              </div>
              <input
                type="text"
                placeholder="Blog yazılarında ara... (başlık, içerik, kategori)"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-12 pr-4 py-4 text-sm bg-white border border-slate-300 rounded-xl focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20 outline-none transition-all placeholder:text-slate-400"
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery('')}
                  className="absolute inset-y-0 right-0 pr-4 flex items-center text-slate-400 hover:text-slate-600 cursor-pointer"
                >
                  <i className="ri-close-line text-lg"></i>
                </button>
              )}
            </div>
          </div>

          {/* Filtre Butonları */}
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="flex flex-wrap items-center gap-3">
              <button
                onClick={() => setSelectedCategory('Tümü')}
                className={`px-4 py-2 rounded-lg font-medium transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2 text-sm ${
                  selectedCategory === 'Tümü'
                    ? 'bg-teal-500 text-white shadow-md'
                    : 'bg-white text-slate-700 hover:bg-slate-100 border border-slate-200'
                }`}
              >
                <span>Tümü</span>
                <span className={`px-1.5 py-0.5 rounded-full text-xs font-bold ${
                  selectedCategory === 'Tümü'
                    ? 'bg-white/20 text-white'
                    : 'bg-slate-100 text-slate-600'
                }`}>
                  {blogPosts.length}
                </span>
              </button>

              <button
                onClick={() => setSelectedCategory('Fiber Optik')}
                className={`px-4 py-2 rounded-lg font-medium transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2 text-sm ${
                  selectedCategory === 'Fiber Optik'
                    ? 'bg-teal-500 text-white shadow-md'
                    : 'bg-white text-slate-700 hover:bg-slate-100 border border-slate-200'
                }`}
              >
                <i className="ri-flashlight-line"></i>
                <span>Fiber Optik</span>
                <span className={`px-1.5 py-0.5 rounded-full text-xs font-bold ${
                  selectedCategory === 'Fiber Optik'
                    ? 'bg-white/20 text-white'
                    : 'bg-slate-100 text-slate-600'
                }`}>
                  {fiberCount}
                </span>
              </button>

              <button
                onClick={() => setSelectedCategory('Güvenlik Sistemleri')}
                className={`px-4 py-2 rounded-lg font-medium transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2 text-sm ${
                  selectedCategory === 'Güvenlik Sistemleri'
                    ? 'bg-teal-500 text-white shadow-md'
                    : 'bg-white text-slate-700 hover:bg-slate-100 border border-slate-200'
                }`}
              >
                <i className="ri-shield-check-line"></i>
                <span>Güvenlik</span>
                <span className={`px-1.5 py-0.5 rounded-full text-xs font-bold ${
                  selectedCategory === 'Güvenlik Sistemleri'
                    ? 'bg-white/20 text-white'
                    : 'bg-slate-100 text-slate-600'
                }`}>
                  {securityCount}
                </span>
              </button>
            </div>

            {/* Sıralama ve Diğer Filtreler */}
            <div className="flex items-center gap-3">
              <div className="relative">
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="appearance-none bg-white border border-slate-200 rounded-lg px-4 py-2 pr-8 text-sm font-medium text-slate-700 cursor-pointer hover:bg-slate-50 focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20 outline-none"
                >
                  <option value="newest">En Yeni</option>
                  <option value="oldest">En Eski</option>
                  <option value="title">Alfabetik</option>
                  <option value="readTime">Okuma Süresi</option>
                </select>
                <i className="ri-arrow-down-s-line absolute right-2 top-1/2 transform -translate-y-1/2 text-slate-400 pointer-events-none"></i>
              </div>

              {(searchQuery || selectedCategory !== 'Tümü' || sortBy !== 'newest') && (
                <button
                  onClick={clearFilters}
                  className="px-4 py-2 text-sm font-medium text-slate-600 hover:text-slate-800 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 transition-all cursor-pointer flex items-center gap-1"
                >
                  <i className="ri-close-line"></i>
                  Temizle
                </button>
              )}
            </div>
          </div>

          {/* Sonuç Sayısı */}
          {(searchQuery || selectedCategory !== 'Tümü') && (
            <div className="mt-4 text-center">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-lg text-sm text-slate-600">
                <i className="ri-file-text-line text-teal-500"></i>
                <span>
                  {filteredPosts.length} makale bulundu
                  {searchQuery && ` "${searchQuery}" için`}
                  {selectedCategory !== 'Tümü' && ` ${selectedCategory} kategorisinde`}
                </span>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Blog Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          {filteredPosts.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredPosts.map((post) => (
                <Link
                  key={post.id}
                  to={`/blog/${post.slug}`}
                  className="group bg-white rounded-2xl overflow-hidden border border-slate-200 hover:border-teal-500 transition-all duration-300 hover:shadow-xl hover:shadow-teal-500/10 hover:-translate-y-1"
                >
                  <div className="relative h-56 w-full overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="px-3 py-1 bg-teal-500 text-white text-xs font-semibold rounded-full">
                        {post.category}
                      </span>
                    </div>
                  </div>

                  <div className="p-6">
                    <div className="flex items-center gap-4 text-sm text-slate-500 mb-3">
                      <div className="flex items-center gap-1">
                        <i className="ri-calendar-line text-xs"></i>
                        <span>{post.date}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <i className="ri-time-line text-xs"></i>
                        <span>{post.readTime}</span>
                      </div>
                    </div>

                    <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-teal-600 transition-colors line-clamp-2">
                      {post.title}
                    </h3>

                    <p className="text-slate-600 text-sm leading-relaxed mb-4 line-clamp-3">
                      {post.excerpt}
                    </p>

                    <div className="flex items-center justify-between pt-4 border-t border-slate-100">
                      {/* Sosyal Medya Paylaşım Butonları */}
                      <div className="flex items-center gap-2">
                        <button
                          onClick={(e) => shareOnFacebook(e, post)}
                          className="share-btn share-btn-fb w-8 h-8 flex items-center justify-center rounded-full bg-slate-100 text-slate-600 cursor-pointer"
                          title="Facebook'ta Paylaş"
                        >
                          <i className="ri-facebook-fill text-sm"></i>
                        </button>
                        <button
                          onClick={(e) => shareOnTwitter(e, post)}
                          className="share-btn share-btn-tw w-8 h-8 flex items-center justify-center rounded-full bg-slate-100 text-slate-600 cursor-pointer"
                          title="X'te Paylaş"
                        >
                          <i className="ri-twitter-x-fill text-sm"></i>
                        </button>
                        <button
                          onClick={(e) => shareOnWhatsApp(e, post)}
                          className="share-btn share-btn-wa w-8 h-8 flex items-center justify-center rounded-full bg-slate-100 text-slate-600 cursor-pointer"
                          title="WhatsApp'ta Paylaş"
                        >
                          <i className="ri-whatsapp-fill text-sm"></i>
                        </button>
                      </div>

                      {/* Devamını Oku Butonu */}
                      <div className="flex items-center gap-1 text-teal-600 font-semibold text-sm group-hover:gap-2 transition-all">
                        <span>Devamını Oku</span>
                        <i className="ri-arrow-right-line"></i>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="max-w-md mx-auto">
                <div className="w-24 h-24 mx-auto mb-6 bg-slate-100 rounded-full flex items-center justify-center">
                  <i className="ri-search-line text-4xl text-slate-400"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Sonuç Bulunamadı</h3>
                <p className="text-slate-600 mb-6">
                  {searchQuery ? `"${searchQuery}" araması için` : 'Seçilen filtreler için'} herhangi bir blog yazısı bulunamadı.
                </p>
                <button
                  onClick={clearFilters}
                  className="px-6 py-3 bg-teal-500 hover:bg-teal-600 text-white font-semibold rounded-xl transition-all duration-300 hover:shadow-lg cursor-pointer"
                >
                  <i className="ri-refresh-line mr-2"></i>
                  Filtreleri Temizle
                </button>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              Profesyonel Fiber Optik ve Güvenlik Çözümleri
            </h2>
            <p className="text-xl text-slate-300 mb-8">
              7/24 acil müdahale hizmeti ile İstanbul ve çevre illerde hizmetinizdeyiz
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <a
                href="tel:+905537165561"
                className="px-8 py-4 bg-teal-500 hover:bg-teal-600 text-white font-semibold rounded-xl transition-all duration-300 hover:shadow-lg cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                Hemen Ara
              </a>
              <a
                href="https://wa.me/905537165561"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-white hover:bg-slate-50 text-slate-900 font-semibold rounded-xl transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp Destek
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}